<h3 class="dialog-title">{{ data.title }}</h3>

<div class="form-section">
  <p class="data-point-text">{{ data.message }}</p>
</div>

<div class="action-buttons">
  <button class="cancel-button" (click)="dialogRef.close(false)">
    Cancel
  </button>
  <button class="save-button" (click)="dialogRef.close(true)">
    Confirm
  </button>
</div>
